import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const hdr = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const KATEGORILER = [
  { value: 'yonetim_direktifi', label: 'Yönetim Direktifi' },
  { value: 'mevzuat',           label: 'Mevzuat Gereği' },
  { value: 'proje',             label: 'Proje' },
  { value: 'toplanti_karari',   label: 'Toplantı Kararı' },
  { value: 'diger',             label: 'Diğer' },
];
const ONCELIKLER = [
  { value: 'kritik', label: 'Kritik' },
  { value: 'yuksek', label: 'Yüksek' },
  { value: 'normal', label: 'Normal' },
  { value: 'dusuk',  label: 'Düşük' },
];
const DURUMLAR = [
  { value: 'yeni',        label: 'Yeni' },
  { value: 'islemde',     label: 'İşlemde' },
  { value: 'askida',      label: 'Askıda' },
  { value: 'tamamlandi',  label: 'Tamamlandı' },
  { value: 'arsiv',       label: 'Arşiv' },
];

const DURUM_RENK: Record<string, string> = {
  yeni: '#3498db', islemde: '#e67e22', askida: '#95a5a6',
  tamamlandi: '#27ae60', arsiv: '#7f8c8d',
};
const ONCELIK_RENK: Record<string, string> = {
  kritik: '#e74c3c', yuksek: '#e67e22', normal: '#2980b9', dusuk: '#27ae60',
};

const emptyForm = {
  baslik: '', aciklama: '', kategori: 'diger', oncelik: 'normal', durum: 'yeni',
  sorumlu_birim_id: '', ilgili_isletme_id: '', baslangic_tarihi: '', son_tarih: '',
};

export default function IsTakipListesi() {
  const nav = useNavigate();
  const [konular,    setKonular]    = useState<any[]>([]);
  const [birimler,   setBirimler]   = useState<any[]>([]);
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [filtre,     setFiltre]     = useState({ durum: '', kategori: '', oncelik: '' });
  const [modal,      setModal]      = useState(false);
  const [secili,     setSecili]     = useState<any>(null);
  const [form,       setForm]       = useState<any>({ ...emptyForm });
  const [hata,       setHata]       = useState('');
  const [yuk,        setYuk]        = useState(false);

  useEffect(() => {
    fetch(`${API}/api/is-takip/referans/birimler`,   { headers: hdr() }).then(r => r.json()).then(d => setBirimler(Array.isArray(d) ? d : [])).catch(() => {});
    fetch(`${API}/api/is-takip/referans/isletmeler`, { headers: hdr() }).then(r => r.json()).then(d => setIsletmeler(Array.isArray(d) ? d : [])).catch(() => {});
    yukle();
  }, []);

  useEffect(() => { yukle(); }, [filtre]);

  const yukle = () => {
    const p = new URLSearchParams();
    if (filtre.durum)    p.set('durum',    filtre.durum);
    if (filtre.kategori) p.set('kategori', filtre.kategori);
    if (filtre.oncelik)  p.set('oncelik',  filtre.oncelik);
    fetch(`${API}/api/is-takip/konular?${p}`, { headers: hdr() })
      .then(r => r.json()).then(setKonular).catch(() => setKonular([]));
  };

  const yeniAc = () => { setSecili(null); setForm({ ...emptyForm }); setHata(''); setModal(true); };
  const duzenleAc = (k: any) => {
    setSecili(k);
    setForm({
      baslik: k.baslik || '', aciklama: k.aciklama || '',
      kategori: k.kategori || 'diger', oncelik: k.oncelik || 'normal', durum: k.durum || 'yeni',
      sorumlu_birim_id: k.sorumlu_birim_id ? String(k.sorumlu_birim_id) : '',
      ilgili_isletme_id: k.ilgili_isletme_id ? String(k.ilgili_isletme_id) : '',
      baslangic_tarihi: k.baslangic_tarihi || '',
      son_tarih: k.son_tarih || '',
    });
    setHata(''); setModal(true);
  };

  const kaydet = async () => {
    if (!form.baslik.trim()) { setHata('Başlık zorunludur'); return; }
    setHata(''); setYuk(true);
    const body = {
      ...form,
      sorumlu_birim_id:  form.sorumlu_birim_id  ? Number(form.sorumlu_birim_id)  : null,
      ilgili_isletme_id: form.ilgili_isletme_id ? Number(form.ilgili_isletme_id) : null,
      baslangic_tarihi:  form.baslangic_tarihi  || null,
      son_tarih:         form.son_tarih         || null,
    };
    try {
      const url    = secili ? `${API}/api/is-takip/konular/${secili.id}` : `${API}/api/is-takip/konular`;
      const method = secili ? 'PUT' : 'POST';
      await fetch(url, { method, headers: { ...hdr(), 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      setModal(false); yukle();
    } catch { setHata('Kayıt hatası'); }
    finally { setYuk(false); }
  };

  const sil = async (id: number) => {
    if (!window.confirm('Bu konu silinsin mi?')) return;
    await fetch(`${API}/api/is-takip/konular/${id}`, { method: 'DELETE', headers: hdr() });
    yukle();
  };

  const inp = (field: string) => (e: any) => setForm((f: any) => ({ ...f, [field]: e.target.value }));

  return (
    <div style={{ padding: '20px 24px', maxWidth: 1100 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ margin: 0, fontSize: 18, color: '#1a3c5e' }}>📁 İş Konuları</h2>
        <button onClick={yeniAc} style={{ background: '#1a5276', color: '#fff', border: 'none', borderRadius: 6, padding: '7px 16px', cursor: 'pointer', fontSize: 13 }}>+ Yeni Konu</button>
      </div>

      {/* Filtreler */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap' }}>
        {(['durum', 'kategori', 'oncelik'] as const).map(f => (
          <select key={f} value={(filtre as any)[f]}
            onChange={e => setFiltre(p => ({ ...p, [f]: e.target.value }))}
            style={{ padding: '5px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 12 }}>
            <option value="">{f === 'durum' ? 'Tüm Durumlar' : f === 'kategori' ? 'Tüm Kategoriler' : 'Tüm Öncelikler'}</option>
            {f === 'durum'    && DURUMLAR.map(d =>    <option key={d.value} value={d.value}>{d.label}</option>)}
            {f === 'kategori' && KATEGORILER.map(k => <option key={k.value} value={k.value}>{k.label}</option>)}
            {f === 'oncelik'  && ONCELIKLER.map(o =>  <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        ))}
        <button onClick={yukle} style={{ padding: '5px 12px', borderRadius: 6, border: '1px solid #ddd', fontSize: 12, cursor: 'pointer' }}>Yenile</button>
      </div>

      {/* Tablo */}
      <div style={{ background: '#fff', borderRadius: 10, boxShadow: '0 1px 4px rgba(0,0,0,.06)', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#f0f4f8' }}>
              {['Başlık', 'Kategori', 'Öncelik', 'Durum', 'Sorumlu Birim', 'Son Tarih', ''].map(h => (
                <th key={h} style={{ padding: '9px 12px', textAlign: 'left', fontWeight: 600, color: '#555', fontSize: 12 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {konular.length === 0 && (
              <tr><td colSpan={7} style={{ padding: 24, textAlign: 'center', color: '#bbb' }}>Kayıt bulunamadı</td></tr>
            )}
            {konular.map(k => (
              <tr key={k.id} style={{ borderBottom: '1px solid #f5f5f5' }}
                onMouseEnter={e => (e.currentTarget.style.background = '#fafcff')}
                onMouseLeave={e => (e.currentTarget.style.background = '')}>
                <td style={{ padding: '9px 12px' }}>
                  <span onClick={() => nav(`/is-takip/${k.id}`)}
                    style={{ cursor: 'pointer', fontWeight: 600, color: '#1a5276' }}>{k.baslik}</span>
                  {k.ilgili_isletme_ad && <span style={{ fontSize: 10, color: '#888', display: 'block' }}>{k.ilgili_isletme_ad}</span>}
                </td>
                <td style={{ padding: '9px 12px', fontSize: 11 }}>
                  {KATEGORILER.find(x => x.value === k.kategori)?.label || k.kategori}
                </td>
                <td style={{ padding: '9px 12px' }}>
                  <span style={{ fontSize: 11, background: `${ONCELIK_RENK[k.oncelik] || '#ccc'}22`,
                    color: ONCELIK_RENK[k.oncelik] || '#555', padding: '2px 7px', borderRadius: 10 }}>
                    {ONCELIKLER.find(x => x.value === k.oncelik)?.label || k.oncelik}
                  </span>
                </td>
                <td style={{ padding: '9px 12px' }}>
                  <span style={{ fontSize: 11, background: `${DURUM_RENK[k.durum] || '#ccc'}22`,
                    color: DURUM_RENK[k.durum] || '#555', padding: '2px 7px', borderRadius: 10 }}>
                    {DURUMLAR.find(x => x.value === k.durum)?.label || k.durum}
                  </span>
                </td>
                <td style={{ padding: '9px 12px', fontSize: 12, color: '#555' }}>{k.sorumlu_birim_ad || '—'}</td>
                <td style={{ padding: '9px 12px', fontSize: 12, color: k.son_tarih && new Date(k.son_tarih) < new Date() ? '#e74c3c' : '#555' }}>
                  {k.son_tarih || '—'}
                </td>
                <td style={{ padding: '9px 12px' }}>
                  <button onClick={() => duzenleAc(k)} style={{ marginRight: 6, background: 'none', border: '1px solid #ddd', borderRadius: 5, padding: '3px 8px', cursor: 'pointer', fontSize: 11 }}>Düzenle</button>
                  <button onClick={() => sil(k.id)} style={{ background: 'none', border: '1px solid #fcc', borderRadius: 5, padding: '3px 8px', cursor: 'pointer', fontSize: 11, color: '#e74c3c' }}>Sil</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 540, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 8px 32px rgba(0,0,0,.2)' }}>
            <h3 style={{ margin: '0 0 20px', fontSize: 16 }}>{secili ? 'Konu Düzenle' : 'Yeni Konu'}</h3>

            <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Başlık *</label>
            <input value={form.baslik} onChange={inp('baslik')}
              style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', marginBottom: 12, boxSizing: 'border-box', fontSize: 13 }} />

            <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Açıklama</label>
            <textarea value={form.aciklama} onChange={inp('aciklama')} rows={3}
              style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', marginBottom: 12, boxSizing: 'border-box', fontSize: 13, resize: 'vertical' }} />

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 12 }}>
              {[
                { label: 'Kategori', field: 'kategori', opts: KATEGORILER },
                { label: 'Öncelik',  field: 'oncelik',  opts: ONCELIKLER },
                { label: 'Durum',    field: 'durum',    opts: DURUMLAR },
              ].map(({ label, field, opts }) => (
                <div key={field}>
                  <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>{label}</label>
                  <select value={form[field]} onChange={inp(field)}
                    style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }}>
                    {opts.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                  </select>
                </div>
              ))}
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
              <div>
                <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Sorumlu Birim</label>
                <select value={form.sorumlu_birim_id} onChange={inp('sorumlu_birim_id')}
                  style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }}>
                  <option value="">Seçiniz</option>
                  {birimler.map((b: any) => <option key={b.id} value={b.id}>{b.ad}</option>)}
                </select>
              </div>
              <div>
                <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>İlgili İşletme</label>
                <select value={form.ilgili_isletme_id} onChange={inp('ilgili_isletme_id')}
                  style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }}>
                  <option value="">Seçiniz</option>
                  {isletmeler.map((i: any) => <option key={i.id} value={i.id}>{i.ad}</option>)}
                </select>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
              <div>
                <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Başlangıç Tarihi</label>
                <input type="date" value={form.baslangic_tarihi} onChange={inp('baslangic_tarihi')}
                  style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Son Tarih</label>
                <input type="date" value={form.son_tarih} onChange={inp('son_tarih')}
                  style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }} />
              </div>
            </div>

            {hata && <div style={{ color: '#e74c3c', fontSize: 12, marginBottom: 10 }}>{hata}</div>}

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={() => setModal(false)} style={{ padding: '7px 18px', borderRadius: 6, border: '1px solid #ddd', cursor: 'pointer', fontSize: 13 }}>İptal</button>
              <button onClick={kaydet} disabled={yuk}
                style={{ padding: '7px 18px', borderRadius: 6, background: '#1a5276', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 13, opacity: yuk ? .6 : 1 }}>
                {yuk ? 'Kaydediliyor...' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
